
import { getUniqueValues } from '../table-helpers';
import { dropdown } from '../../dropdown';

/**
 * Function to clear all inputs in a table filter
 * 
 * @param {string} elementClass css class name for the filter elements.
 * 
 * @returns void
 */
export const filterClear = (elementClass: string) => {
  let tableInputClear = Array.from(document.querySelectorAll<HTMLInputElement>(elementClass));

  [...tableInputClear].forEach(ele => {
    if(ele.type === 'date') {
      ele.value = '';
    } else if (ele.type === 'checkbox') {
      ele.checked = false;
    } else if (ele.type === 'radio') {
      ele.id === 'aafp_transaction-payment-type' ? ele.checked = true : ele.checked = false;
    } else if (ele.name === 'payment') {
      ele.value = '0';
    } else if (ele.type === 'number') {
      ele.value = '';
    } else if (ele.type === 'search') {
      ele.value = '';
    } else if (ele.type === 'text') {
      ele.value = '';
    } else if (ele.dataset.value) {
      ele.removeAttribute('data-value');
      ele.innerHTML = 'Please Select';
    }      
  });
}

/**
 * Formats a unique list of customers for a dropdown.
 * 
 * @param {object} tableData the data
 * 
 * @returns void
 */
export const cardGroupDropDown = ( tableData: object ) => {
  let cardGroupList: object[] = [];

  for(const [key, value] of Object.entries(tableData)) {
    cardGroupList.push({ id: value.cardGroupId, name: value.cardGroupName });
  }

  let finalCGList: object  = getUniqueValues(cardGroupList, 'id');

  dropdown(finalCGList, 'two', 'CardGroup', true, true, true);
}

/**
 * Formats a unique list of terminals for a dropdown.
 * 
 * @param {object} tableData the data
 * 
 * @returns void
 */
export const terminalDropDown = (tableData: object = {}) => {
  if (!tableData || Object.keys(tableData).length === 0) return;

  // @ts-ignore
  tableData = tableData.sort((a: any, b: any) => {
    if (a.terminalId < b.terminalId) {
      return -1;
    }
    if (a.terminalId > b.terminalId) {
      return 1;
    }
    return 0;
  });

  let terminalList: object[] = [];

  for( const [ key, value ] of Object.entries(tableData) ) {
    let terminalFinalName = '';
    if ( value.terminalId != value.terminalName && value.terminalName != '') {
      terminalFinalName = `${value.terminalId} - ${value.terminalName}`;
    } else {
      terminalFinalName = value.terminalId;
    }
    terminalList.push({ id: value.terminalId, name: terminalFinalName });
  }

  let finalTList: object = getUniqueValues(terminalList, 'id');

  dropdown(finalTList, 'five', 'Terminal', true, true, true);
}

/**
 * Formats a unique list of customers for a dropdown.
 * 
 * @param {object} tableData the data
 * 
 * @returns void
 */
export const customerDropDown = (tableData: object = {}) => {
  if (!tableData || Object.keys(tableData).length === 0) return;
  
  let customerList: object[] = [];

  // @ts-ignore 
  tableData = tableData.sort((a: any, b: any) => {
    if (a.customerName < b.customerName) {
      return -1;
    }
    if (a.customerName > b.customerName) {
      return 1;
    }
    return 0;
  });

  for ( const [ key, value ] of Object.entries(tableData) ) {
    customerList.push({ id: value.customerId, name: value.customerName });
  }

  let finalCList: object = getUniqueValues(customerList, 'id');

  dropdown(finalCList, 'six', 'Customer', true, true, true);
}